import {
  type ThemeConfigWithBasicColors,
  defaultThemeConfigWithBasicColors,
} from "@hopper-b2b/themes";

export const colors: ThemeConfigWithBasicColors =
  defaultThemeConfigWithBasicColors;
